export default __webpack_public_path__ + "static/media/b13.7975e862.jpg";